<template>
	<div>
		<div
			class="su-blue-container fw-M fs-22 font-manrope color-4A7EFF d-flex align-items-end justify-content-between"
		>
			<span class="sf-py-16px"> Complete Sign Up to get started now </span>

			<img
				src="@/assets/newonboarding/chatbubble1-img.svg"
				class="sigupformimage"
				alt=""
			/>
		</div>

		<section class="su-inputs">
			<b-row class="mt-24px">
				<b-col cols="6">
					<div class="position-relative">
						<div class="fw-LM fs-12 fam-inter color-757575">
							First Name<span class="asterik">*</span>
						</div>
						<b-form-input
							v-model.trim="$v.form.firstName.$model"
							placeholder="First Name"
							:class="{ 'is-invalid': $v.form.firstName.$error }"
							@input="handleFirstNameInput"
							@beforeinput="(e) => blockInvalidNameBefore(e, true)"
							@keypress="
								(e) => {
									if (!/[a-zA-Z ]/.test(e.key)) e.preventDefault();
								}
							"
						></b-form-input>
						<div v-if="$v.form.firstName.$error" class="su-error-text">
							<span v-if="!$v.form.firstName.required"
								>First name is required</span
							>
							<span v-else-if="!$v.form.firstName.maxLength"
								>Should not exceed 38 characters</span
							>
							<span v-else-if="!$v.form.firstName.onlyAlphaSpace"
								>Only letters and spaces allowed</span
							>
						</div>
					</div>
				</b-col>
				<b-col cols="6">
					<div class="position-relative">
						<div class="fw-LM fs-12 fam-inter color-757575">
							Last Name<span class="asterik">*</span>
						</div>
						<b-form-input
							v-model.trim="$v.form.lastName.$model"
							placeholder="Last Name"
							:class="{ 'is-invalid': $v.form.lastName.$error }"
							@input="handleLastNameInput"
							@beforeinput="(e) => blockInvalidNameBefore(e, false)"
							@keypress="
								(e) => {
									if (!/[a-zA-Z]/.test(e.key)) e.preventDefault();
								}
							"
						></b-form-input>
						<div v-if="$v.form.lastName.$error" class="su-error-text">
							<span v-if="!$v.form.lastName.required"
								>Last name is required</span
							>
							<span v-else-if="!$v.form.lastName.maxLength"
								>Should not exceed 38 characters</span
							>
							<span v-else-if="!$v.form.lastName.onlyAlpha"
								>Only letters allowed</span
							>
						</div>
					</div>
				</b-col>
			</b-row>

			<!-- EMAIL field: shown when phone === true OR no check data yet -->
			<b-row v-if="!showPhoneField" class="mt-24px">
				<b-col cols="12">
					<div class="position-relative">
						<div class="fw-LM fs-12 fam-inter color-757575">
							Email ID<span class="asterik">*</span>
						</div>
						<b-form-input
							v-model.trim="$v.form.email.$model"
							placeholder="Email ID"
							type="email"
							:class="{ 'is-invalid': $v.form.email.$error || emailExists }"
						></b-form-input>
						<div
							v-if="$v.form.email.$error && !$v.form.email.required"
							class="su-error-text"
						>
							Email is required
						</div>
						<div
							v-else-if="$v.form.email.$error && !$v.form.email.email"
							class="su-error-text"
						>
							Please enter a valid email
						</div>
						<div
							v-else-if="$v.form.email.$error && !$v.form.email.maxLength"
							class="su-error-text"
						>
							Should not exceed 64 characters
						</div>
						<div v-else-if="emailExists" class="su-error-text">
							Email already exists
						</div>
					</div>
				</b-col>
			</b-row>

			<!-- PHONE field: shown when email === true -->
			<b-row v-if="showPhoneField" class="mt-24px">
				<b-col cols="12">
					<div class="position-relative">
						<div class="fw-LM fs-12 fam-inter color-757575">
							Phone Number<span class="asterik">*</span>
						</div>

						<PhoneNumber
							id="phoneNumber"
							label="Phone Number"
							type="tel"
							:from-signup-form="true"
							:mandatory="true"
							placeholder="Enter phone number"
							:code="form.countryCode"
							:vmodel="form.phone"
							:showError="$v.form.phone.$error || phoneInvalid"
							@select-value="
								form.phone = String($event);
								$v.form.phone.$touch();
							"
							@select-country-code="form.countryCode = $event"
							@phonevalidation="handlePhoneValidation($event)"
						/>
						<div
							v-if="$v.form.phone.$error || phoneInvalid"
							class="su-error-text"
						>
							{{
								phoneInvalid && !$v.form.phone.$error
									? "Please enter a valid phone number"
									: phoneErrorMessage
							}}
						</div>
					</div></b-col
				>
			</b-row>

			<b-row class="mt-24px">
				<b-col cols="12">
					<div class="position-relative">
						<div class="fw-LM fs-12 fam-inter color-757575">
							Promo Code/College Code
						</div>
						<b-form-input
							v-model.trim="form.code"
							placeholder="Promo Code/College Code"
							:class="{ 'is-invalid': promoError }"
							@input="promoError = ''"
						></b-form-input>
						<div v-if="promoError" class="su-error-text">{{ promoError }}</div>
					</div>
				</b-col>
			</b-row>
		</section>

		<section class="mt-36px mb-1 w-100">
			<button
				class="skybluebtn w-100 fam-inter text-white fs-14 text-center d-flex align-items-center justify-content-center"
				:disabled="
					$v.$invalid ||
					isSubmitting ||
					(showPhoneField && phoneInvalid) ||
					emailExists
				"
				:style="{
					opacity:
						$v.$invalid || (showPhoneField && phoneInvalid) || emailExists
							? 0.4
							: 1,
					cursor:
						$v.$invalid || (showPhoneField && phoneInvalid) || emailExists
							? 'not-allowed'
							: 'pointer',
				}"
				@click="handleSignUp"
			>
				<b-spinner v-if="isSubmitting" small label="Loading..."></b-spinner>
				<span v-else>
					Lets goooo
					<img src="@/assets/newonboarding/rocket.svg" class="ml-1" alt="" />
				</span>
			</button>
		</section>
	</div>
</template>

<script>
import {
	required,
	email,
	numeric,
	maxLength,
	helpers,
} from "vuelidate/lib/validators";

const onlyAlphaSpace = helpers.regex("onlyAlphaSpace", /^[a-zA-Z ]*$/);
const onlyAlpha = helpers.regex("onlyAlpha", /^[a-zA-Z]*$/);
import {
	userSignUp,
	getCandidateOnboard,
	userInfo,
	checkCandidateDirect,
  	setMobileToken,
	refreshAccessToken,
} from "@/utils/apiFunctions";
import EventBus from "@/utils/EventBus.js";
import PhoneNumber from "@/components/InputComponents/PhoneNumber.vue";
import { Capacitor } from "@capacitor/core";
import { getMobileToken } from '@/utils/tokenCheck';
import { trackSignupDetailsFilled } from "@/utils/posthogHelpers";
export default {
	name: "SignupForm",
	components: { PhoneNumber },
	props: {
		signinCheckData: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			isSubmitting: false,
			promoError: "",
			phoneInvalid: false,
			emailExists: false,
			_emailCheckTimer: null,
			form: {
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				countryCode: "+91",
				code: "",
			},
		};
	},
	watch: {
		// Validate on every keystroke
		"form.phone"(val) {
			if (!this.showPhoneField) return;
			this.phoneInvalid = this.isPhoneInvalid(val, this.form.countryCode);
		},
		// Re-validate when country code switches
		"form.countryCode"() {
			if (!this.showPhoneField) return;
			this.phoneInvalid = this.isPhoneInvalid(
				this.form.phone,
				this.form.countryCode
			);
		},
		// First name allows a single space between names (e.g. "Sai Ram").
		// Strip special chars / emoji regardless of input method, collapse any
		// run of spaces to one, and drop a leading space.
		"form.firstName"(newVal) {
			if (newVal) {
				const cleaned = newVal
					.replace(/[^a-zA-Z ]/g, "")
					.replace(/\s+/g, " ")
					.replace(/^\s/, "")
					.replace(/ {2,}/g, " ");
				if (cleaned !== newVal) {
					this.form.firstName = cleaned;
				}
			}
		},
		"form.lastName"(newVal) {
			if (newVal) {
				const cleaned = newVal.replace(/[^a-zA-Z]/g, "");
				if (cleaned !== newVal) {
					this.form.lastName = cleaned;
				}
			}
		},
		"form.email"(newVal) {
			if (newVal) {
				this.form.email = newVal.replace(/\s/, "").toLowerCase();
			}
			// Reset whenever the user keeps typing
			this.emailExists = false;
			clearTimeout(this._emailCheckTimer);
			// Only call API once the email passes basic format validation
			const isValidFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
				(newVal || "").trim()
			);
			if (!isValidFormat) return;
			this._emailCheckTimer = setTimeout(async () => {
				try {
					const res = await checkCandidateDirect({
						email: (newVal || "").trim().toLowerCase(),
					});
					if (res?.data?.data?.isCandidateValid === true) {
						this.emailExists = true;
					}
				} catch (e) {
					// Silently ignore — do not block signup on API failure
				}
			}, 500);
		},
	},
	computed: {
		// email: true in response → take input of phone (showPhoneField = true)
		// phone: true in response → take input of email (showPhoneField = false)
		showPhoneField() {
			if (!this.signinCheckData) return false;
			console.log(
				"[SignupForm] Received signinCheckData:",
				this.signinCheckData
			);
			const isEmailTrue =
				this.signinCheckData.email === true ||
				this.signinCheckData.email === "true";
			const isPhoneTrue =
				this.signinCheckData.phone === true ||
				this.signinCheckData.phone === "true";
			if (isEmailTrue) {
				console.log(
					"[SignupForm] email is true -> prompting for Phone number input"
				);
				return true; // email is true -> take input of phone
			}
			if (isPhoneTrue) {
				console.log(
					"[SignupForm] phone is true -> prompting for Email ID input"
				);
				return false; // phone is true -> take input of email
			}
			return false;
		},
		phoneFieldError() {
			return this.$v.form.phone.$error;
		},
		phoneErrorMessage() {
			if (!this.$v.form.phone.required) return "Phone number is required";
			if (!this.$v.form.phone.numeric) return "Only digits are allowed";

			return "Please enter a valid phone number";
		},
	},
	validations() {
		if (this.showPhoneField) {
			return {
				form: {
					firstName: { required, onlyAlphaSpace, maxLength: maxLength(38) },
					lastName: { required, onlyAlpha, maxLength: maxLength(38) },
					email: {},
					phone: {
						required,
						numeric,
					},
					code: {},
				},
			};
		}
		return {
			form: {
				firstName: { required, onlyAlphaSpace, maxLength: maxLength(38) },
				lastName: { required, onlyAlpha, maxLength: maxLength(38) },
				email: { required, email, maxLength: maxLength(64) },
				phone: {},
				code: {},
			},
		};
	},
	methods: {
	
		handleFirstNameInput(value) {
			const cleaned = (value || "")
				.replace(/[^a-zA-Z ]/g, "")
				.replace(/\s+/g, " ")
				.replace(/^\s/, "")
				.replace(/ {2,}/g, " ");
			if (cleaned !== value) {
				this.form.firstName = cleaned;
			}
		},
		handleLastNameInput(value) {
			const cleaned = (value || "").replace(/[^a-zA-Z]/g, "");
			if (cleaned !== value) {
				this.form.lastName = cleaned;
			}
		},

		blockInvalidNameBefore(e, allowSpace) {
			const pattern = allowSpace ? /^[a-zA-Z ]*$/ : /^[a-zA-Z]*$/;
			const data = e.data || e.dataTransfer?.getData?.("text");
			if (data != null && !pattern.test(data)) {
				e.preventDefault();
			}
		},
		isPhoneInvalid(number, countryCode) {
			const dialCode = (countryCode || "").toString().replace(/[\s+]/g, "");
			const clean = (number || "").replace(/\s+/g, "");
			if (!clean) return false;
			if (dialCode === "91") return !/^[6-9]\d{9}$/.test(clean);
			return false; // non-IN: delegate to PhoneNumber component via @phonevalidation
		},
		handlePhoneValidation(isInvalid) {
			const dialCode = (this.form.countryCode || "")
				.toString()
				.replace(/[\s+]/g, "");
			if (dialCode === "91") {
				const clean = (this.form.phone || "").replace(/\s+/g, "");
				this.phoneInvalid = !/^[6-9]\d{9}$/.test(clean);
			} else {
				this.phoneInvalid = isInvalid;
			}
		},
		async handleSignUp() {
			this.$v.$touch();
			if (this.$v.$invalid) return;
			if (this.isSubmitting) return;

			this.isSubmitting = true;
			try {
				const payload = {
					firstName: this.form.firstName,
					lastName: this.form.lastName,
					code: this.form.code,
				};

				const storedUuid = localStorage.getItem("uuid");
				if (storedUuid) {
					payload.uuid = storedUuid;
				}

				if (this.showPhoneField) {
					payload.countryCode = (this.form.countryCode || "").replace(
						/[^0-9]/g,
						""
					);
					payload.phoneNumber = this.form.phone;
				} else {
					payload.email = this.form.email;
				}

				const response = await userSignUp(payload);
				const status = response?.status;
				const responseData = response?.data;

				if (responseData?.type === "Fail") {
					const detail = responseData?.data?.Detail;
					this.promoError = detail || "Something went wrong. Please try again.";
					return;
				}

				if (status === 200 || status === 208) {
					if(Capacitor.isNativePlatform()){
						const token = getMobileToken();
						try {
							if (token) {
								await setMobileToken({
									token,
									platform: Capacitor.getPlatform(),
								});
							}
						} catch (error) {
							console.error("Notification error:", error);
						}
					}
					// Refresh access token in the background after signup
					await refreshAccessToken();
					trackSignupDetailsFilled(payload);
					// Notify router to clear uuid from localStorage
					EventBus.$emit("signup-complete");

					// 1. Fetch onboarding status before closing so we know what to open next
					const onboardRes = await getCandidateOnboard();
					const onboardData = onboardRes?.data?.data;

					// 2. Fetch user info to get firstName for welcome step
					let firstName = "";
					try {
						const userInfoRes = await userInfo();
						firstName =
							userInfoRes?.data?.data?.firstName ||
							userInfoRes?.data?.firstName ||
							"";
					} catch (e) {
						console.warn("[SignupForm] userInfo fetch failed:", e);
					}

					// 3. Stop spinner before closing so it doesn't get stuck on unmount
					this.isSubmitting = false;

					// 4. Close the signup modal
					this.$emit("next");

					// 5. Wait for the modal to fully unmount, then open onboarding modal
					await this.$nextTick();
					setTimeout(() => {
						// Always start from the welcome step (step 1) after a fresh signup
						EventBus.$emit("show-onboarding-modal", { firstName });
					}, 400);
				}
			} catch (err) {
				const detail =
					err?.response?.data?.data?.Detail || err?.response?.data?.Detail;
				this.promoError = detail || "Something went wrong. Please try again.";
			} finally {
				this.isSubmitting = false;
			}
		},
	},
};
</script>

<style scoped>
.skybluebtn {
	padding: 12px 24px;
	background: #4a7eff;
	border-radius: 40px;
	border: unset;
	cursor: pointer;
	height: 48px;
}
.color-757575 {
	color: #757575;
}
.color-4A7EFF {
	color: #4a7eff;
}
.sf-py-16px {
	padding-bottom: 16px;
	padding-top: 16px;
}
.su-blue-container {
	padding: 0 16px;
	background: linear-gradient(
		90deg,
		rgba(74, 126, 255, 0.06) 0%,
		rgba(0, 38, 134, 0.06) 100%
	);
	border: 0.5px solid rgba(239, 239, 239, 0.14);
	border-radius: 32px;
}
.mb-36px {
	margin-bottom: 36px;
}
.mt-24px {
	margin-top: 24px;
}
.mt-36px {
	margin-top: 36px;
}
.su-error-text {
	position: absolute;
	font-family: "Inter", sans-serif;
	color: #eb0002;
	font-size: var(--size-10);
	font-weight: var(--weight-R);
}

/* Phone field styles */
.su-phone-wrapper {
	display: flex;
	align-items: center;
	height: 48px;
	background: #ffffff;
	border: 1px solid #e2e8f0;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
	border-radius: 32px;
	overflow: hidden;
	padding: 0 16px;
}
.su-phone-wrapper--invalid {
	border-color: #e53e3e;
}
.su-country-select-wrapper {
	position: relative;
	display: flex;
	align-items: center;
	flex-shrink: 0;
}
.su-country-select {
	appearance: none;
	-webkit-appearance: none;
	border: none;
	outline: none;
	background: transparent;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #2d3748;
	padding-right: 18px;
	cursor: pointer;
}
.su-country-arrow {
	position: absolute;
	right: 0;
	font-size: 10px;
	color: #718096;
	pointer-events: none;
}
.su-phone-divider {
	width: 1px;
	height: 24px;
	background: #e2e8f0;
	margin: 0 12px;
	flex-shrink: 0;
}
.su-phone-input {
	flex: 1;
	border: none;
	outline: none;
	font-family: "Inter", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #2d3748;
	background: transparent;
}
.su-phone-input::placeholder {
	color: #ababab;
}
</style>

<style>
.su-inputs .form-control:invalid:focus,
.su-inputs .form-control.is-invalid:focus {
	box-shadow: unset;
}
.su-inputs .form-control {
	padding: 16px 24px;
	height: 48px;
	background: #ffffff;
	border: 1px solid #e2e8f0;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
	border-radius: 32px;
}
.su-inputs .form-control::placeholder {
	font-family: "Inter", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #ababab;
}
.su-inputs .form-control.is-invalid {
	border-color: #e53e3e !important;
	background-image: none;
}
.su-inputs .form-control.is-invalid {
	border-color: #e53e3e;
	background-image: none;
}
.su-inputs .form-control:focus {
	border: 1px solid #4a7eff;
	box-shadow: none;
}

@media (max-width: 1028px) {
	.sigupformimage {
		height: 43%;
	}
}
</style>
